import script from "./CompletedFormView.vue?vue&type=script&setup=true&lang=js"
export * from "./CompletedFormView.vue?vue&type=script&setup=true&lang=js"

import "./CompletedFormView.vue?vue&type=style&index=0&id=c5562244&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c5562244"]])

export default __exports__